import {type CardDeckStatsFragment, ControlCardCategory} from "app/gql/graphqlSchema";
import {useMemo} from "react";
import {isNil} from "app/utils/stdlib";
import {IonBadge} from "@ionic/react";

interface Props {
  stats: CardDeckStatsFragment[];
  category: ControlCardCategory;
}

export const IncompleteInstanceCount = ({stats, category}: Props) => {
  const count = useMemo(
    () => stats.find((s) => s.category === category)?.rangeStats.incompleteCount,
    [stats, category]
  );

  if (isNil(count) || count === 0) {
    return null;
  }
  return <IonBadge>{count}</IonBadge>;
};
